<template>
  <div class="emd-panel__section">
    <div class="emd-panel__block">
      <div class="el-chunk">
        <h2 class="emd-text _color_default _type_caption">
          {{ $t(acquirer.payment_method) }}
        </h2>
      </div>
    </div>
    <div class="emd-panel__block">
      <JadeBox>
        <div
          class="eu-display_flex eu-row eu-align-items_center eu-justify_space-between"
        >
          <jade-list-item
            class="h-20"
            :label="acquirer.affiliation_code"
            :description="description"
          >
            <template #leading>
              <component :is="acquirerImageComponent" />
            </template>

            <template #trailing>
              <div
                class="emd-form-group"
                v-if="acquirer.merchant_acquirer_agreement_id"
              >
                <jade-text>
                  {{ $t('status') }}
                </jade-text>
                <span class="emd-input-helper"></span>

                <label
                  class="emd-switcher__label"
                  :for="switchId"
                >
                  <input
                    v-model="acquirer.is_enabled"
                    :id="switchId"
                    type="checkbox"
                    class="emd-switcher"
                    :class="{
                      _color_success: acquirer.is_enabled
                    }"
                    @input="$emit('handleChange', acquirer)"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">
                    {{ $t('active') }}
                  </span>
                </label>
              </div>
            </template>
          </jade-list-item>
        </div>
      </JadeBox>
    </div>
  </div>
</template>

<script>
import { JadeBox, JadeText, JadeButton, JadeListItem } from '@jade'
import { ICON_COMPONENT_MAP } from '../affiliations-payment-methods.enum'

export default {
  name: 'AffiliationSettingsItem',

  components: {
    JadeBox,
    JadeText,
    JadeButton,
    JadeListItem
  },

  props: {
    acquirer: {
      type: Object,
      required: true
    }
  },

  computed: {
    acquirerImageComponent () {
      return ICON_COMPONENT_MAP[this.acquirer.payment_method]
    },

    switchId () {
      return `switcher-${this.acquirer.merchant_acquirer_agreement_id}`
    },

    description () {
      return this.$t(
        `description.${
          this.acquirer.merchant_acquirer_agreement_id ? 'edit' : 'create'
        }`
      )
    }
  }
}
</script>

<i18n src="../affiliations.translation.json" />

<i18n>
  {
    "pt-BR": {
      "status": "Status",
      "active": "Ativo",
      "description.create": "Confirme sua senha para concluir o cadastro.",
      "description.edit": "Adquirente cadastrada"
    },
    "en-US": {
      "status": "Status",
      "active": "Active",
      "description.create": "Confirm your password to complete the registration.",
      "description.edit": "Registered acquirer"
    }
  }
</i18n>
